import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { getOrgTokens } from '../../theme/style/organizationPalette';

const UsageTabs = ({ options, selected, setSelected }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const tok = getOrgTokens(isDark);

    return (
        <Box sx={{
            display: 'flex',
            width: '100%',
            p: 0.6,
            borderRadius: tok.radius.tabContainer || '14px',
            bgcolor: tok.bg.tabContainer,
            border: '1px solid',
            borderColor: tok.border.card,
            mb: 4,
            maxWidth: 'fit-content'
        }}>
            {options.map((option) => {
                const isActive = selected === option.value;
                const Icon = option.tabIcon;

                return (
                    <Box
                        key={option.value}
                        onClick={() => setSelected(option.value)}
                        sx={{
                            display: 'flex',
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1.2,
                            px: 3,
                            py: 1.2,
                            borderRadius: tok.radius.tabItem || '10px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            bgcolor: isActive ? tok.bg.tabActive : 'transparent',
                            color: isActive ? '#ffffff' : tok.text.muted,
                            border: '1px solid',
                            borderColor: isActive ? 'transparent' : 'transparent',
                            boxShadow: isActive ? tok.shadow.card : 'none',
                            '&:hover': {
                                bgcolor: isActive ? tok.bg.tabActive : tok.bg.tabHover,
                                color: isActive ? '#ffffff' : tok.text.primary,
                            }
                        }}
                    >
                        {Icon && <Icon size={18} />}
                        <Typography sx={{
                            fontWeight: tok.font.weight.bold,
                            fontSize: tok.font.size.tabLabel,
                            letterSpacing: '0.01em',
                            whiteSpace: 'nowrap',
                            color: 'inherit',
                            fontFamily: tok.font.family
                        }}>
                            {option.label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default UsageTabs;
